// CUSTOM_CODE
/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      let cartSubmitClass = '.btn.cart__submit';
      if (this.append === '-Drawer') {
        cartSubmitClass = '.btn.quick-cart__submit';
      }
      this.checkout_button = this.parentNode.querySelector(cartSubmitClass);
      if (this.terms_checkbox && this.checkout_button) {
        this.terms_checkbox.setCustomValidity(this.dataset.requireterms);
        this.checkout_button.addEventListener('click', (e) => {
          if (!this.terms_checkbox.checked) {
            this.terms_checkbox.reportValidity();
            this.terms_checkbox.focus();
            e.preventDefault();
          }
        });
      }
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}
// END_CUSTOM_CODE
